import axios from 'axios';

const getMcpTools = () => {
  return axios.get('mcp/tools');
};

export { getMcpTools };
